import { render, staticRenderFns } from "./AssignSavedQuote.vue?vue&type=template&id=5da5b7e8&scoped=true"
import script from "./AssignSavedQuote.vue?vue&type=script&lang=ts"
export * from "./AssignSavedQuote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5b7e8",
  null
  
)

export default component.exports